import { render, staticRenderFns } from "./tab1V2.vue?vue&type=template&id=a957eb6e&scoped=true&"
import script from "./tab1V2.vue?vue&type=script&lang=js&"
export * from "./tab1V2.vue?vue&type=script&lang=js&"
import style0 from "./tab1V2.vue?vue&type=style&index=0&id=a957eb6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a957eb6e",
  null
  
)

export default component.exports